import { Box, Grid } from '@mui/material';
import domtoimage from 'dom-to-image';
import { useEffect, useState } from 'react';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** STYLE */

import 'features/counter/doctor-schedule/table-style.css';
/** API */
import DoctorScheduleApi from 'api/counter/doctor-schedule.api';

/** COMPONENT */

/** UTILS || SLICE */
import { closeModal } from 'app/slice/modal.slice';
import { notiSuccess } from 'component/notifications/notifications';
import { getNameMonthByNo } from 'constants/date-time';
import { colors } from 'constants/theme';
import _ from 'lodash';
import moment from 'moment';
import MainButton from 'new-components/buttons/main-button';
import RadioButton from 'new-components/buttons/radio-button';
import AlertModal from 'new-components/modal/alert-modal';
import PageModal from 'new-components/modal/page-modal';
import { useDispatch, useSelector } from 'react-redux';
import { isBuddhistYear, numberToCurrencyFormat, padCode } from 'utils/app.utils';
import { createDaysForCurrentMonth, createDaysForNextMonth, createDaysForPreviousMonth } from 'utils/calendar-helper.utils';

interface ShareInterface {
  data: any
}

interface IFDoctors {
  isChecked: boolean | false
  doctorFullname: string
  positionName: string
  positionNameEn: string
  avatar: string | null
  doctorId: number
  branchId: number
  month: string
  year: string
  monthSchedule: string
  firstDate: string
}

interface AlertAction { onClick: () => void, title: string }
type AlertType = "error" | "warning" | "success"

interface ConfigAlert {
  isOpen: boolean
  title: string
  message?: string
  type: AlertType
  onCloseCancel: boolean
  onCloseSubmit: boolean
  onCancel: AlertAction
  onSubmit: AlertAction
  handleClose: () => void
}

const initialConfigAlert: ConfigAlert = {
  isOpen: false,
  title: '',
  message: '',
  type: 'error',
  onCloseCancel: false,
  onCloseSubmit: false,
  onCancel: { onClick: () => undefined, title: '' },
  onSubmit: { onClick: () => undefined, title: '' },
  handleClose: () => undefined
}

export default function DoctorScheduleShare(prop: ShareInterface) {

  const { t, i18n } = useTranslation()
  const lang = i18n?.language || 'th'
  const isShow = useSelector((state: any) => state.modal.isShow)
  const dispatch = useDispatch()
  const [shareType, setShareType]: any = useState('IMAGE')
  const [dataSchedule, setDataSchedule]: any = useState(prop.data.dataSchedule)
  const [email, setEmail]: any = useState(prop.data.email)
  const [doctorFullname, setDoctorFullname]: any = useState(prop.data.doctorFullname)
  const [month, setMonth]: any = useState(prop.data.month)
  const [year, setYear]: any = useState(prop.data.year)
  const [branchId, setBranchId]: any = useState(prop.data.branchId)
  const [doctorId, setDoctorId]: any = useState(prop.data.doctorId)
  const [configAlert, setConfigAlert] = useState<ConfigAlert>(initialConfigAlert)


  const currentMonthDays = createDaysForCurrentMonth(year, month)
  const previousMonthDays = createDaysForPreviousMonth(year, month, currentMonthDays)
  const nextMonthDays = createDaysForNextMonth(year, month, currentMonthDays)
  const [calendarGridDayObjects, setCalendarGridDayObjects]: any = useState([...previousMonthDays, ...currentMonthDays, ...nextMonthDays])

  const getColorStatus = (status: string, type: 'TEXT' | 'BG') => {
    if (type === 'BG') {
      let bgColorSchedule: any = colors.white
      if (status === 'LEAVE_WORK') bgColorSchedule = colors.doctorScheduleStatus.leave
      else if (status === 'MISSING') bgColorSchedule = colors.doctorScheduleStatus.missing
      return bgColorSchedule
    }
    if (type === 'TEXT') {
      let txtColorSchedule: any = colors.black
      if (status === 'LEAVE_WORK') txtColorSchedule = colors.textPrimary
      else if (status === 'MISSING') txtColorSchedule = colors.textPrimary
      else if (status === 'NORMAL') txtColorSchedule = colors.white
      return txtColorSchedule
    }
  }
  useEffect(() => {
    const { data: { dataSchedule, email, doctorFullname, month, year, branchId, doctorId } } = prop
    const currenShareMonthDays = createDaysForCurrentMonth(year, month)
    const previousShareMonthDays = createDaysForPreviousMonth(year, month, currenShareMonthDays)
    const nextShareMonthDays = createDaysForNextMonth(year, month, currenShareMonthDays)
    const calendarShareGridDayObjects = [...previousShareMonthDays, ...currenShareMonthDays, ...nextShareMonthDays]
    setCalendarGridDayObjects(calendarShareGridDayObjects)
    setDataSchedule(dataSchedule)
    setEmail(email)
    setDoctorFullname(doctorFullname)
    setMonth(month)
    setYear(year)
    setBranchId(branchId)
    setDoctorId(doctorId)
  }, [prop.data])

  function isValiEmail(value: string) {
    const pattern = /\S+@\S+\.\S+/;
    const valid = pattern.test(value);
    return valid
  }

  const sendMail = async () => {
    if (!email || !isValiEmail(email)) {
      return setConfigAlert({
        isOpen: true,
        title: t('DOCTOR_SCHEDULE.MESSAGE.WARNING.NONE_EMAIL'),
        message: t('DOCTOR_SCHEDULE.MESSAGE.WARNING.NONE_EMAIL_SHARE_SUB'),
        type: 'warning',
        onCloseCancel: false,
        onCloseSubmit: true,
        onCancel: { onClick: () => setConfigAlert(initialConfigAlert), title: t('BUTTON.ENTER') },
        onSubmit: { onClick: async () => setConfigAlert(initialConfigAlert), title: t('DOCTOR_SCHEDULE.BUTTON.ENTER') },
        handleClose: () => setConfigAlert(initialConfigAlert)
      })

    }
    const node = document.getElementById("div-schedule");
    if (node) {
      let base64: any = await domtoimage.toPng(node);
      base64 = base64.split(',')

      DoctorScheduleApi.send({
        type: shareType,
        branchId,
        date: `${year}-${padCode(2, month)}-01`,
        doctorId: doctorId.toString(),
        base64: base64[base64.length - 1],
        filename: `${t('DOCTOR_SCHEDULE.SHARE.DOCTOR_TABLE')} ${getNameMonthByNo(parseInt(month), lang)} ${getYear(year)}`,
      }).then(async (res) => {
        if (res.status !== undefined && res.status === 201) notiSuccess(t('DOCTOR_SCHEDULE.MESSAGE.SUCCESS.EMAIL_SUCCESS'))
        else notiSuccess(t('DOCTOR_SCHEDULE.MESSAGE.ERROR_TRYAGAIN'))
      })
    }
  }

  const handleDownloadImage = async () => {
    const node = document.getElementById("div-schedule");
    if (node) {
      domtoimage.toPng(node).then(function (dataUrl) {
        const link = document.createElement('a');
        link.download = `${t('DOCTOR_SCHEDULE.SHARE.DOCTOR_TABLE')} ${getNameMonthByNo(parseInt(month), lang)} ${getYear(year)}.png`;
        link.href = dataUrl;
        link.click();
      });
    }
  };

  const getYear = (year: string) => {
    return lang === 'th' ? parseInt(year) + isBuddhistYear() : year
  }


  return (
    <PageModal
      isOpen={isShow}
      size={'M'}
      title={t('DOCTOR_SCHEDULE.SHARE.SHARE_TABLE')}
      handleClose={() => dispatch(closeModal())}
      onCloseCancel={false}
      onCloseSubmit={true}
      onSubmit={{ onClick: () => null }}
      onCancel={{ onClick: () => dispatch(closeModal()) }}
      overflow={false}
    >
      <Box>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} sm={3} md={3} xl={2}> <Box fontWeight="500" fontSize={'16px'}> {t('DOCTOR_SCHEDULE.SHARE.TYPE_DOCTOR')} </Box></Grid>
          <Grid item xs>
            <RadioButton
              name="share-row-radio-buttons-group"
              row
              value={shareType}
              onChange={e => { if (e.target.value) setShareType(e.target.value) }}
              options={[
                { value: 'IMAGE', label: t('DOCTOR_SCHEDULE.SHARE.PICTURE') },
                { value: 'MAIL', label: `${t('DOCTOR_SCHEDULE.SHARE.EMAIL')}: ${email}` },
              ]}
            />
          </Grid>
          <Grid item>
            <Box fontSize={'16px'} fontWeight="400">{t('DOCTOR_SCHEDULE.SHARE.DOCTOR')} {doctorFullname} </Box>
          </Grid>
          <Grid item>
            <Box fontSize={'16px'} fontWeight="400">
              {t('DOCTOR_SCHEDULE.SHARE.MONTHLY')}
              {getNameMonthByNo(parseInt(month), lang)} {getYear(year)}
            </Box>
          </Grid>
          <Grid item>
            <MainButton
              title={t('DOCTOR_SCHEDULE.BUTTON.SHARE')}
              onClick={shareType === 'IMAGE' ? handleDownloadImage : sendMail}
              type="primary"
              variant="contained"
              style={{ width: '90px' }}
              height='30'
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            bgcolor: 'white',
            mt: 2,
            borderRadius: 1,
            boxShadow: 1,
            px: 2,
            py: 1,
            maxHeight: '65vh',
            overflowY: 'auto',
            overflowX: 'auto',
          }}
        >
          <Box
            id="div-schedule"
            sx={{
              width: '1130px'
            }}
          >
            <div style={{ padding: 5, backgroundColor: colors.white }} >
              <meta charSet="UTF-8" />
              <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link href="https://fonts.googleapis.com/css2?family=Sarabun:wght@400;500;600&display=swap" rel="stylesheet" />
              <title>{t('DOCTOR_SCHEDULE.SHARE.DOCTOR_TABLE')}</title>
              <style dangerouslySetInnerHTML={{
                __html: `\n
                .div-image p {\n margin: 0;\n }\n\n   
                .div-image.mockup-a4-landscape {\n        
                    font-family: 'Sarabun', sans-serif;\n
                    font-size: 10px;\n
                    -webkit-print-color-adjust: exact;\n
                    margin: 0;\n color: ${colors.textPrimary};\n      
                    width: 1130px;\n height: 705px;\n margin: auto;\n }\n\n   
                    .div-image .bg-primary {
                      background-color: #2F4269 !important;
                      font-size: 16px;
                      font-weight: 400;
                      height: 29px;
                      display: flex;
                      align-items: center;
                      padding: 0 8px;
                    } 
                .div-image .text-primary {\n color: ${colors.themeSecondColor};\n    }\n\n   
                .div-image .day-of-week-header-cell {
                  background-color: ${colors.lightGray};
                  color: #29302E;
                  font-size: 17px;
                  font-weight: 500;
                  height: 29px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 0;
                  margin: 0;
                }
                .div-image .grid-item {\n display: grid;\n grid-template-columns: 14.28% 14.28% 14.28% 14.28% 14.28% 14.28% 14.28%;\n align-items: center;\n }\n\n   
                .div-image .day {\n border: 1px solid ${colors.lightGray};\n height: 95px;\n padding: 2px;\n overflow: hidden;\n margin: 3px 3px;\n  border-radius: 1px;\n }\n\n   
                .div-image .day-text {\n text-align: center;\n font-size: 14px;\n font-weight: 500;\n margin: 0 3px;\n}\n\n   
                .div-image .day-number {\n 
                  float: left;\n 
                  font-size: 11px;\n 
                  font-weight: 500;\n 
                  color: ${colors.textPrimary};\n 
                }\n
                 .div-image .day-number.current-month {
                    border: 1px solid ${colors.lightGray};\n 
                    border-radius: 10px;\n 
                    width: 20px;\n 
                    height: 20px;\n 
                    justify-content: center;\n 
                    align-items: center;\n 
                    display: flex;\n 
                 } ` }} />
              <div style={{ padding: 5 }} className="div-image mockup-a4-landscape" >
                <div style={{ display: 'grid', gridTemplateColumns: 'auto  ', alignItems: 'center', paddingTop: '16px' }}>
                  <div className="bg-primary" style={{ color: colors.white, padding: '4px 8px', fontSize: '16px', fontWeight: '400', margin: '0 8px', background: '#2F4269' }}>
                    {t('DOCTOR_SCHEDULE.SHARE.DOCTOR_TABLE')}  {t('DOCTOR_SCHEDULE.SHARE.MONTH')}: {getNameMonthByNo(parseInt(month), lang)} {getYear(year)} <span style={{ paddingLeft: '4px' }}></span>
                  </div>
                </div>
                <div className="grid-item" style={{ padding: '14px 8px 8px', color: ' #29302E' }}>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.SUNDAY')}</div>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.MONDAY')}</div>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.TUESDAY')}</div>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.WEDNESDAY')}</div>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.THURSDAY')}</div>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.FRIDAY')}</div>
                  <div className="day-text day-of-week-header-cell">{t('DOCTOR_SCHEDULE.SHARE.SATURDAY')}</div>
                </div>
                <div className="grid-item " style={{ padding: '4px 8px 16px', justifyContent: 'center' }}>
                  {_.map(calendarGridDayObjects, (i, index) => {
                    let daySchdule = dataSchedule.find((schedule: any) => schedule.date === i.dateString)
                    daySchdule = daySchdule?.schedule[0]
                    const dayOfMonth = i.dayOfMonth
                    const isCurrentMonth = i.isCurrentMonth

                    return daySchdule && (
                      <div style={{ backgroundColor: getColorStatus(daySchdule?.statusDoctorSchedule, 'BG'), height: '100%' }}>
                        <div className="  day">
                          <span className="day-number current-month">{dayOfMonth}</span>
                          {daySchdule.statusDoctorSchedule === 'NORMAL' ? (
                            <div className=" d-flex overflow-hidden" style={{ marginTop: '20px', marginLeft: '2px' }}>
                              <div style={{ paddingLeft: 1 }} className="name-doctor text-nowrap-ellipsis -overflow-hidden ">
                                <p className="mb-0 fc-main  text-nowrap-ellipsis">
                                  <strong>{String(daySchdule.doctorFullname || '')}</strong>
                                </p>
                                <p className="mb-0 text-muted time-doctor text-nowrap-ellipsis">
                                  {daySchdule.statusDoctorSchedule === 'NORMAL' ? (
                                    <div style={{ fontSize: 10, color: colors.textExtraLightGray }}>
                                      {`${moment(String(daySchdule.timeStart || '00:00'), 'HH:mm').format('HH.mm น.')} - ${moment(String(daySchdule.timeEnd || '00:00'), 'HH:mm').format('HH.mm น.')}`} ({daySchdule.countAppoints} {t('DOCTOR_SCHEDULE.MEETUP')})
                                    </div>
                                  ) : (
                                    <div style={{ fontSize: 14, height: '100%', justifyItems: 'center', color: getColorStatus(daySchdule.statusDoctorSchedule, 'TEXT'), fontWeight: 'bold' }}>{daySchdule.statusDoctorSchedule ? `(${t(`DOCTOR_SCHEDULE.STATUS.${daySchdule.statusDoctorSchedule}`)})` : '-'}</div>
                                  )}
                                </p>
                                {daySchdule.statusDoctorSchedule === 'NORMAL' && <>
                                  <p
                                    style={{
                                      fontSize: '10px',
                                      margin: 0,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      width: '100%'
                                    }}
                                  >
                                    <strong>{t('DOCTOR_SCHEDULE.ASSISTANT')}</strong>: {' '}
                                    {daySchdule
                                      ?.doctorScheduleAssistants
                                      ?.map((as: any) => as.staffFullname)
                                      .join(', ') || '-'}
                                  </p>
                                  {daySchdule.doctors.isInsure === '1' ? <p className="mb-0 fz-12 text-nowrap-ellipsis">
                                    <strong>{t('DOCTOR_SCHEDULE.GUARANTEE')}</strong>: {numberToCurrencyFormat(daySchdule.handInsurance)} {t('DOCTOR_SCHEDULE.CURRENCY')}
                                  </p> : <></>}
                                </>}
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex flex-center" style={{ height: 'calc(100% - 32px)', justifyContent: 'center', textAlign: 'center', marginTop: '16px', transform: 'translateX(-10px)' }}>
                              {daySchdule.statusDoctorSchedule ? t(`DOCTOR_SCHEDULE.STATUS.${daySchdule.statusDoctorSchedule}`) : '-'}
                            </div>
                          )}
                        </div>
                      </div>
                    ) || (
                        <div className="day"  >
                          {isCurrentMonth ? <span className="day-number current-month">{dayOfMonth}</span> : <span className="day-number" />}
                        </div>
                      )
                  })}
                </div>
              </div>
            </div>
          </Box>
        </Box>
        <AlertModal
          isOpen={configAlert.isOpen}
          title={configAlert.title}
          message={configAlert.message}
          type={configAlert.type}
          onCloseCancel={configAlert.onCloseCancel}
          onCloseSubmit={configAlert.onCloseSubmit}
          handleClose={() => configAlert.handleClose}
          onCancel={configAlert.onCancel}
          onSubmit={configAlert.onSubmit}
        />
      </Box>
    </PageModal>
  )
}



